import {
  FETCH_BANK_FIELD_REQUIREMENTS,
  FETCH_BANK_FIELD_REQUIREMENTS_SUCCESS,
  FETCH_BANK_FIELD_REQUIREMENTS_FAILED,
  EDIT_BANK_FIELD_REQUIREMENTS,
  EDIT_BANK_FIELD_REQUIREMENTS_SUCCESS,
  EDIT_BANK_FIELD_REQUIREMENTS_FAILED,
  CLEAR_BANK_FIELD_ERROR
} from "../store/types";

import { firebase } from '../config/configureFirebase';
import { onValue, set, get } from "firebase/database";

export const fetchBankFieldRequirements = () => (dispatch) => {
  const {
    bankFieldRequirementsRef
  } = firebase;

  // Add validation to prevent undefined reference errors
  if (!bankFieldRequirementsRef) {
    console.error('❌ bankFieldRequirementsRef is not defined in Firebase config');
    dispatch({
      type: FETCH_BANK_FIELD_REQUIREMENTS_FAILED,
      payload: "Firebase configuration error: bankFieldRequirementsRef not found",
    });
    return;
  }

  dispatch({
    type: FETCH_BANK_FIELD_REQUIREMENTS,
    payload: null,
  });

  onValue(bankFieldRequirementsRef, (snapshot) => {
    if (snapshot.val()) {
      dispatch({
        type: FETCH_BANK_FIELD_REQUIREMENTS_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      // Set default field requirements if none exist
      const defaultRequirements = {
        accountHolderName: { show: true, required: true, driver: true, user: true },
        accountNumber: { show: true, required: true, driver: true, user: true },
        iban: { show: false, required: false, driver: false, user: false },
        bankName: { show: true, required: true, driver: true, user: true },
        bankCode: { show: false, required: false, driver: false, user: false },
        branchCode: { show: false, required: false, driver: false, user: false },
        routingNumber: { show: false, required: false, driver: false, user: false },
        swiftCode: { show: false, required: false, driver: false, user: false },
        bankAddress: { show: false, required: false, driver: false, user: false },
        accountType: { show: false, required: false, driver: false, user: false },
        currency: { show: false, required: false, driver: false, user: false },
        country: { show: true, required: true, driver: true, user: true },
        recipientAddress: { show: false, required: false, driver: false, user: false },
        emailOrPhone: { show: false, required: false, driver: false, user: false },
        enableForUsers: true,
        enableForDrivers: true
      };
      
      dispatch({
        type: FETCH_BANK_FIELD_REQUIREMENTS_SUCCESS,
        payload: defaultRequirements,
      });
    }
  }, (error) => {
    dispatch({
      type: FETCH_BANK_FIELD_REQUIREMENTS_FAILED,
      payload: "Unable to fetch bank field requirements: " + error.message,
    });
  });
};

export const editBankFieldRequirements = (requirements) => (dispatch) => {
  const {
    bankFieldRequirementsRef
  } = firebase;

  // Add validation to prevent undefined reference errors
  if (!bankFieldRequirementsRef) {
    console.error('❌ bankFieldRequirementsRef is not defined in Firebase config');
    dispatch({
      type: EDIT_BANK_FIELD_REQUIREMENTS_FAILED,
      payload: "Firebase configuration error: bankFieldRequirementsRef not found",
    });
    return;
  }

  dispatch({
    type: EDIT_BANK_FIELD_REQUIREMENTS,
    payload: requirements
  });

  // Add timestamp for tracking
  const requirementsWithTimestamp = {
    ...requirements,
    updatedAt: new Date().getTime(),
    updatedBy: firebase.auth?.currentUser?.uid || 'system'
  };

  set(bankFieldRequirementsRef, requirementsWithTimestamp)
    .then(() => {
      console.log('✅ Bank field requirements updated successfully');
      dispatch({
        type: EDIT_BANK_FIELD_REQUIREMENTS_SUCCESS,
        payload: requirementsWithTimestamp
      });
    })
    .catch((error) => {
      console.error('❌ Error updating bank field requirements:', error);
      dispatch({
        type: EDIT_BANK_FIELD_REQUIREMENTS_FAILED,
        payload: `Error updating bank field requirements: ${error.message}`
      });
    });
};

export const getBankFieldRequirements = async () => {
  const {
    bankFieldRequirementsRef
  } = firebase;

  // Add validation to prevent undefined reference errors
  if (!bankFieldRequirementsRef) {
    console.error('❌ bankFieldRequirementsRef is not defined in Firebase config');
    throw new Error('Firebase configuration error: bankFieldRequirementsRef not found');
  }

  try {
    const snapshot = await get(bankFieldRequirementsRef);
    if (snapshot.val()) {
      return snapshot.val();
    } else {
      // Return default requirements if none exist
      return {
        accountHolderName: { show: true, required: true, driver: true, user: true },
        accountNumber: { show: true, required: true, driver: true, user: true },
        iban: { show: false, required: false, driver: false, user: false },
        bankName: { show: true, required: true, driver: true, user: true },
        bankCode: { show: false, required: false, driver: false, user: false },
        branchCode: { show: false, required: false, driver: false, user: false },
        routingNumber: { show: false, required: false, driver: false, user: false },
        swiftCode: { show: false, required: false, driver: false, user: false },
        bankAddress: { show: false, required: false, driver: false, user: false },
        accountType: { show: false, required: false, driver: false, user: false },
        currency: { show: false, required: false, driver: false, user: false },
        country: { show: true, required: true, driver: true, user: true },
        recipientAddress: { show: false, required: false, driver: false, user: false },
        emailOrPhone: { show: false, required: false, driver: false, user: false },
        enableForUsers: true,
        enableForDrivers: true
      };
    }
  } catch (error) {
    console.error('❌ Error fetching bank field requirements:', error);
    throw error;
  }
};

export const clearBankFieldError = () => (dispatch) => {
  dispatch({
    type: CLEAR_BANK_FIELD_ERROR,
    payload: null
  });
};